import 'v-tooltip/dist/v-tooltip.css'
import {  
  MethodsFastReport,
    MethodsStrGet,
    MethodsStrSingleGet,
    MethodsStrSabitGet,
    MethodsStrFilterGet,
    MethodsStrFileGet,
    MethodsStrPost,
    MethodsStrPut,
    MethodsStrDelete, 
    GenericComputed 
    } from "@/state/helpers";

    import moment from "moment"; 
const Sabit = {
    data() {
      return { 
      }
    },
    methods: {
    ...MethodsFastReport,
    ...MethodsStrGet,
    ...MethodsStrSingleGet,
    ...MethodsStrSabitGet,
    ...MethodsStrFilterGet,
    ...MethodsStrFileGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrDelete,  
                ChangePage(DefaultPage) {
                    if(DefaultPage){ 
                        this.Page.PageNumber = DefaultPage
                        this.Get(); 
                    }
                }
    },
    computed: {
      ...GenericComputed 
    }, 
    created(){   
        this.Get();    
    }, 
    mounted() {
      setTimeout(() => {
        this.showModal = true;
      }, 1500);
    }, 
    filters: {
      formatDate(value) {
        if (value) {
          return moment(String(value)).format("YYYY-MM-DD");
        }
      },
      formatDateTable(value) {
        if (value) {
          return moment(String(value)).format("DD.MM.YYYY");
        }
      },
      formatYuzde(value) {
        if (value) {
          return  value.split('.').join(',');
        }
      },
    },
     
  }
 
  export default Sabit
